<template>
  <nav class="mx-auto flex w-full max-w-7xl items-center justify-between px-4 py-3 md:px-8">
    <router-link to="/" class="group flex items-center gap-3">
      <div class="flex h-11 w-11 items-center justify-center overflow-hidden rounded-lg border border-[var(--border)] bg-[var(--panel)] accent-glow">
        <img src="../assets/CWABlogo.png" :alt="$t('navbar.logoAlt')" class="h-full w-full object-cover" />
      </div>
      <div class="hidden sm:block">
        <p class="text-sm font-semibold text-[var(--text-primary)]">{{ $t('navbar.brandName') }}</p>
        <p class="text-xs uppercase tracking-[0.25em] text-[var(--text-muted)]">{{ $t('navbar.brandTagline') }}</p>
      </div>
    </router-link>

    <div class="flex items-center gap-3">
      <div class="hidden items-center gap-3 md:flex">
        <ul class="flex items-center gap-2">
          <li v-for="item in navLinks" :key="item.to">
            <router-link
              :to="item.to"
              class="rounded-lg px-3 py-2 text-sm font-medium text-[var(--text-muted)] transition-all duration-200 hover:text-[var(--accent)]"
              active-class="bg-[var(--panel)] text-[var(--accent)] border border-[var(--border)]"
            >
              {{ $t(item.labelKey) }}
            </router-link>
          </li>
        </ul>
        <div class="flex items-center gap-2">
          <button
            class="rounded-lg border border-[var(--border)] px-2.5 py-1 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--text-muted)] transition hover:text-[var(--accent)]"
            type="button"
            @click="toggleTheme"
          >
            {{ currentTheme === 'dark' ? $t('theme.dark') : $t('theme.light') }}
          </button>
        </div>
      </div>
      <button
        @click="mobileOpen = !mobileOpen"
        class="inline-flex items-center rounded-lg border border-[var(--border)] bg-[var(--panel)] px-3 py-2 text-sm text-[var(--text-secondary)] md:hidden"
        type="button"
      >
        {{ $t('navbar.menu') }}
      </button>
    </div>
  </nav>

  <div v-if="mobileOpen" class="border-t border-[var(--border)] bg-[var(--panel)] md:hidden">
    <ul class="mx-auto flex max-w-7xl flex-col px-4 py-3">
      <li v-for="item in navLinks" :key="`mobile-${item.to}`">
        <router-link
          :to="item.to"
          @click="mobileOpen = false"
          class="block rounded-lg px-3 py-2 text-sm font-medium text-[var(--text-secondary)] hover:bg-[var(--chip-bg)] hover:text-[var(--accent)]"
          active-class="bg-[var(--chip-bg)] text-[var(--accent)]"
        >
          {{ $t(item.labelKey) }}
        </router-link>
      </li>
      <li class="mt-2 px-3">
        <button
          class="w-full rounded-lg border border-[var(--border)] px-2.5 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--text-muted)]"
          type="button"
          @click="toggleTheme"
        >
          {{ currentTheme === 'dark' ? $t('theme.dark') : $t('theme.light') }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { NAV_LINKS } from '@/constants/navigation';

export default {
  name: "NavbarMenu",
  data() {
    return {
      navLinks: NAV_LINKS,
      mobileOpen: false,
      currentTheme: 'dark',
    };
  },
  mounted() {
    const storedTheme = typeof window !== 'undefined'
      ? window.localStorage.getItem('preferredTheme')
      : null;
    this.applyTheme(storedTheme || 'dark');
  },
  methods: {
    applyTheme(theme) {
      this.currentTheme = theme;
      if (typeof document !== 'undefined') {
        document.documentElement.classList.toggle('theme-light', theme === 'light');
      }
      if (typeof window !== 'undefined') {
        window.localStorage.setItem('preferredTheme', theme);
      }
    },
    toggleTheme() {
      const nextTheme = this.currentTheme === 'dark' ? 'light' : 'dark';
      this.applyTheme(nextTheme);
      this.mobileOpen = false;
    },
  },
};
</script>
